import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { NotificationEmailsResponse } from 'src/types/email_notifications';
import axiosInstance from 'src/utils/axios';

const useNotificationEmailsQuery = () =>
  useQuery<NotificationEmailsResponse>({
    queryKey: queryKeys.client.notificationEmails(),
    queryFn: async () => {
      const res = await axiosInstance.get<NotificationEmailsResponse>(
        api.getNotificationEmails
      );
      return res.data;
    },
  });

export default useNotificationEmailsQuery;
